// extracted by mini-css-extract-plugin
export var tabs = "tabs-module--tabs--IR16T";
export var tabListItem = "tabs-module--tabListItem--57a2I";
export var tabListActive = "tabs-module--tabListActive--O90dx";
export var activeTabBorderColorGrowth = "tabs-module--activeTabBorderColorGrowth--cq2bP";
export var activeTabBorderColorCustomers = "tabs-module--activeTabBorderColorCustomers--65O8M";
export var activeTabBorderColorTechnology = "tabs-module--activeTabBorderColorTechnology--h0Vc2";
export var tabContent = "tabs-module--tabContent--0OAiR";